const ALLOWED_TAGS = new Set(['b', 'strong', 'i', 'em', 'u', 'span', 'a', 'br', 'p']);

export function stripHtml(value) {
  if (!value) return '';
  return String(value)
    .replace(/<br\s*\/?>/gi, ' ')
    .replace(/<[^>]+>/g, '')
    .replace(/\s+/g, ' ')
    .trim();
}

export function normalizeStoredText(value) {
  if (!value || typeof value !== 'string' || !value.includes('&')) return value;

  let text = value;
  for (let i = 0; i < 4; i += 1) {
    const textarea = document.createElement('textarea');
    textarea.innerHTML = text;
    const decoded = textarea.value;
    if (decoded === text) break;
    text = decoded;
  }
  return text;
}

export function getEditablePlainText(element) {
  if (!element) return '';
  return (element.textContent || '').replace(/\s+/g, ' ').trim();
}

export function hasRichHtml(value) {
  return typeof value === 'string' && /<[a-z][\s\S]*>/i.test(value);
}

export function sanitizeRichHtml(html) {
  if (!html) return '';

  const doc = new DOMParser().parseFromString(html, 'text/html');

  const cleanNode = (node) => {
    const children = [...node.childNodes];
    children.forEach((child) => {
      if (child.nodeType !== Node.ELEMENT_NODE) return;

      const tag = child.tagName.toLowerCase();
      if (!ALLOWED_TAGS.has(tag)) {
        const parent = child.parentNode;
        while (child.firstChild) parent.insertBefore(child.firstChild, child);
        parent.removeChild(child);
        return;
      }

      if (tag === 'a') {
        const href = child.getAttribute('href') || '';
        child.removeAttribute('target');
        child.removeAttribute('rel');
        child.removeAttribute('class');
        child.removeAttribute('style');
        if (/^https?:\/\//i.test(href)) {
          child.setAttribute('href', href);
          child.setAttribute('rel', 'noopener noreferrer');
        } else {
          child.removeAttribute('href');
        }
      } else if (tag === 'span') {
        const color = child.style?.color || '';
        child.removeAttribute('class');
        child.removeAttribute('style');
        if (color) child.style.color = color;
      } else {
        [...child.attributes].forEach((attr) => child.removeAttribute(attr.name));
      }

      cleanNode(child);
    });
  };

  cleanNode(doc.body);
  return doc.body.innerHTML.replace(/&nbsp;/g, ' ').trim();
}

export function applyRichTextCommand(command, value = null) {
  if (typeof document === 'undefined') return;
  document.execCommand('styleWithCSS', false, true);
  document.execCommand(command, false, value);
}

export const RICH_TEXT_COLORS = [
  { label: 'Default', value: 'inherit' },
  { label: 'Red', value: '#c01f2d' },
  { label: 'Dark red', value: '#b30000' },
  { label: 'Orange', value: '#ff7a00' },
  { label: 'Black', value: '#111111' },
  { label: 'White', value: '#ffffff' },
];
